import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import { SignInForm } from './sign-in-form'
import Auth from '../../auth/auth'
import { JWT_EXPIRED } from 'pobble-components/dist/cookies'
import { toast } from 'pobble-components/dist/toast'
import Cookies from 'js-cookie'
import koala from './sign-in-koala.png'
import { Link } from 'react-router-dom'
import { Oauth } from '../../oauth/oauth'
import { useOrigin } from '../../../common/utils'

const SignIn = injectSheet(({ FONT_SIZES, BREAKPOINTS }) => ({
  container: {
    background: '#FAFAFA',
    minHeight: '100vh',
    paddingLeft: '24px',
    paddingRight: '24px'
  },
  signInBox: {
    padding: '56px 48px 32px',
    borderRadius: '8px',
    background: '#fff',
    boxShadow: '0 20px 25px rgba(0, 0, 0, .1)',
    display: 'flex',
    flexDirection: 'column',
    gap: '48px',
    maxWidth: '400px',
    width: '100%',
    margin: '0 24px'
  },
  divider: {
    margin: '0',
    position: 'relative',
    height: '1px',
    background: '#ECEDEA',
    font: 'var(--body--)',
    '& span': {
      position: 'absolute',
      left: '50%',
      top: '0',
      margin: '-14px 0 0 -10px',
      padding: '6px',
      background: '#fff'
    }
  },
  title: {
    textAlign: 'center',
    margin: '0',
    font: 'var(--heading-)',
    color: 'var(--gray)'
  },
  manual: {
    display: 'flex',
    flexDirection: 'column',
    gap: '48px'
  },
  signUp: {
    textAlign: 'center',
    color: 'var(--gray--)',
    '& a': {
      color: 'var(--dark-blue)',
      '&:hover, &:focus': {
        color: 'var(--dark-blue-)'
      }
    }
  },
  bg: {
    position: 'absolute',
    left: '50%',
    top: '230px',
    width: '867px',
    marginLeft: '-434px',
    pointerEvents: 'none',
    display: 'none',
    '@media (min-width: 541px)': {
      display: 'block'
    }
  },
  studentSignIn: {
    margin: '8px 0 24px',
    padding: '8px 16px',
    borderRadius: '16px',
    background: 'hsl(0 0% 95% / 1)',
    '& a': {
      color: 'var(--dark-blue)',
      '&:hover, &:focus': {
        color: 'var(--dark-blue-)'
      }
    }
  }
}))(({ classes }) => {
  useOrigin()

  useEffect(() => {
    Cookies.set('VISITED_SIGNIN', true, { expires: 1 })
    if (JWT_EXPIRED.get()) {
      JWT_EXPIRED.remove()
      toast.warn('It looks like you were signed out. Please sign in again.')
    }
  }, [])

  return (
    <Auth className={classes.container}>
      <p className={classes.studentSignIn}>
        Are you a student? <a href="/pupil-auth">Sign-in here</a>
      </p>
      <div className={classes.signInBox}>
        <img className={classes.bg} src={koala} alt="koala" />
        <h2 className={classes.title}>
          Welcome back{' '}
          <span role="img" aria-label="wave">
            👋
          </span>
        </h2>
        <Oauth />
        <p className={classes.divider}>
          <span>or</span>
        </p>
        <div className={classes.manual}>
          <SignInForm />
          <div className={classes.signUp}>
            Don't have an account? <Link to="/sign-up">Sign up</Link>
          </div>
        </div>
      </div>
    </Auth>
  )
})

export default SignIn
